export default {
      id: "sli-switch-usage",
      viewBox: "-1.6 -1.6 19.2 19.2",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-switch",
      toString: function () {
        return this.url;
      }
    }